<template>
  <div class="device-detail-location-bd" :class="{ 'full-screen': fullScreen }">
    <div class="device-detail-location-wrap">
      <div id="container" ref="container"></div>
      <!-- 缩放工具 -->
      <div class="amap-tool">
        <div class="location" @click="toolHandle('center')">
          <i class="icon icon-dianziweilan"></i>
        </div>
        <div class="zoom ubv">
          <div class="ub-f1" @click="toolHandle('add')">
            <i class="icon icon-shebeiyewuxinxi1"></i>
          </div>
          <div class="bar"></div>
          <div class="ub-f1" @click="toolHandle('reduce')">
            <i class="icon icon-shebeiyewuxinxi11"></i>
          </div>
        </div>
      </div>
      <!-- Tab(围栏/定位) -->
      <div class="tab-box tab ub">
        <div class="ub" v-if="!isShowFenceDialog&& (propsFuncView.deviceDetail_location_fence || propsFuncView.deviceDetail_location_positioning)">
          <div class="ub-f1 line" v-if="propsFuncView.deviceDetail_location_fence" :class="{ cur: showTab === 'fence' }" @click="changeTab('fence')">
            <i class="icon icon-dianziweilan"></i>
            <span>&ensp;{{ $t('dms_device_detail_location_google.she_bei_wei_lan') }}</span>
          </div>
          <div class="ub-f1 line" v-if="propsFuncView.deviceDetail_location_positioning" :class="{ cur: showTab === 'location' }" @click="changeTab('location')">
            <i class="icon icon-dingwei"></i>
            <span>&ensp;{{ $t('dms_device_detail_location_google.fu_zhu_ding_wei') }}</span>
          </div>
        </div>
        <div class="full-btn" @click="fullScreen = !fullScreen">
          <i v-if="!fullScreen" class="icon icon-quanping2"></i>
          <i v-if="fullScreen" class="icon icon-quanping11"></i>
        </div>
      </div>
      <!-- 设备围栏 -->
      <template v-if="showTab === 'fence' && propsFuncView.deviceDetail_location_fence">
        <!-- 围栏列表 -->
        <div class="fence-list" v-if="!isShowFenceDialog">
          <h1 class="tit">
            {{ $t('dms_device_detail_location_google.wei_lan_lie_biao') }}
            <span @click="isShow = !isShow">
              {{ isShow ? $t('dms_device_detail_location_google.shou_qi') : $t('dms_device_detail_location_google.zhan_kai') }}
              <i class="icon icon-xiala" v-if="!isShow"></i>
              <i v-else class="icon icon-shangla"></i>
            </span>
          </h1>
          <div style="padding: 0 16px 16px" v-if="isShow">
            <div class="add-fence" @click="onFenceAdd()">
              <i class="icon icon-add"></i>
              <span>&ensp;{{ $t('dms_device_detail_location_google.tian_jia_wei_lan') }}</span>
            </div>
            <ul>
              <li class="ub" v-for="(item, index) in fenceList" :key="index" :class="[{ disable: !item.state }, { cur: curFence.fenceId === item.fenceId }]">
                <span class="ub-f1 line1" @click="onCurrentFence(item)">{{ item.fenceName }}</span>
                <i v-if="item.state" class="icon icon-jinyong1" @click="onFenceState(item)"></i>
                <i v-else class="icon icon-qiyong" @click="onFenceState(item)"></i>
                <i class="icon icon-bianji" @click="onFenceUpdate(item)"></i>
                <i class="icon icon-shanchu" @click="onFenceDel(item)"></i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 新增围栏 -->
        <div class="aside-box" v-if="isShowFenceDialog">
          <h1 class="tit">{{ fenceDialogTitle }}</h1>
          <div style="padding: 0 16px 16px">
            <div style="height: 10px"></div>
            <el-form label-position="top" label-width="80px">
              <el-form-item :label="$t('dms_device_detail_location_google.wei_lan_ming_cheng')" v-if="form.fenceType === 1">
                <el-input v-model="form.fenceName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_location_google.ding_wei_fan_wei')" v-if="form.fenceType === 1">
                <el-slider style="margin: 0 4px" @input="changeSider" v-model="form.fenceScope" :max="10000" :min="500"></el-slider>
                <div class="ub marks-tip">
                  <div>500m</div>
                  <div>10000m</div>
                </div>
              </el-form-item>
            </el-form>
            <div class="ub">
              <el-button style="width: 100%" @click="onFenceCancel()">{{ $t('Common.com_cancel') }}</el-button>
              <el-button type="primary" style="width: 100%" @click="onFenceSave()">{{ $t('Common.com_save') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 辅助定位 -->
      <template v-if="showTab === 'location' && propsFuncView.deviceDetail_location_positioning">
        <!-- 辅助列表 -->
        <div class="fence-list" v-if="!isShowLocationDialog">
          <h1 class="tit">
            {{ $t('dms_device_detail_location_google.fu_zhu_ding_wei') }}
            <span @click="isShow = !isShow">
              {{ isShow ? $t('dms_device_detail_location_google.shou_qi') : $t('dms_device_detail_location_google.zhan_kai') }}
              <i class="icon icon-xiala" v-if="!isShow"></i>
              <i v-else class="icon icon-shangla"></i>
            </span>
          </h1>
          <div style="padding: 0 16px 16px" v-if="isShow">
            <div class="add-fence" @click="onLocationAdd()">
              <i class="icon icon-add"></i>
              <span>&ensp;{{ $t('dms_device_detail_location_google.fu_zhu_ding_wei') }}</span>
            </div>
            <ul>
              <li class="ub" v-for="(item, index) in locationList" :key="index" :class="[{ disable: !item.state }, { cur: curLocation.locationId === item.locationId }]">
                <span class="ub-f1 line1" @click="onCurrentLocation(item)">{{ item.gpsAddress }}</span>
                <i v-if="item.state" class="icon icon-jinyong1" @click="onLocationState(item)"></i>
                <i v-else class="icon icon-qiyong" @click="onLocationState(item)"></i>
                <i class="icon icon-bianji" @click="onLocationUpdate(item)"></i>
                <i class="icon icon-shanchu" @click="onLocationDel(item)"></i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 新增辅助 -->
        <div class="aside-box" v-if="isShowLocationDialog">
          <h1 class="tit">{{ fenceDialogTitle }}</h1>
          <div style="padding: 0 16px 16px">
            <div style="height: 10px"></div>
            <el-form label-position="top" label-width="80px">
              <el-form-item :label="$t('dms_device_detail_location_google.dang_qian_wei_zhi')">
                <div class="address">
                  <i class="el-icon-location"></i>
                  <span v-if="locForm.gpsAddress">{{ locForm.gpsAddress }}</span>
                  <a @click="getGeocoder" v-else href="javascript:void(0)" style="color: #0d9ae0; text-decoration: underline">{{ $t('dms_device_detail_location_google.hqdwxx') }}</a>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dms_device_detail_location_google.ding_wei_fan_wei')">
                <el-slider style="margin: 0 4px" v-model="locForm.radius" :max="10000" :min="500" @input="changeSider"></el-slider>
                <div class="ub marks-tip">
                  <div>500m</div>
                  <div>10000m</div>
                </div>
              </el-form-item>
            </el-form>
            <div class="ub">
              <el-button style="width: 100%" @click="onLocationCancel()">{{ $t('Common.com_cancel') }}</el-button>
              <el-button type="primary" style="width: 100%" @click="onLocationSave()">{{ $t('Common.com_save') }}</el-button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

let map = null; // 地图
let circle = null;
let dit = null;
let circleList = []; // 围栏
let ditList = []; // 中心圆点

export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    propsFuncView: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapType: 'google', // 地图类型
      fullScreen: false, // 是否全屏
      searchKey: '', // 搜索关键字

      isShow: true,
      showTab: '', // fence, location
      isShowFenceDialog: false,
      fenceDialogTitle: '',
      isShowLocationDialog: false,
      curFence: {},
      curLocation: {},
      fenceList: [],
      locationList: [],
      form: {
        fenceId: '',
        deviceId: '',
        fenceAddress: '',
        fenceData: '',
        fenceName: '',
        fenceScope: 500,
        fenceType: 1,
        state: 1,
        zoomLevel: 16,
      },
      locForm: {
        locationId: '',
        deviceId: '',
        gpsAddress: '',
        lat: '',
        lng: '',
        radius: 500,
        state: 1,
      },
    };
  },
  mounted: function () {
    this.resetForm = JSON.stringify(this.form);
    this.resetLocForm = JSON.stringify(this.locForm);
    this.initMap(() => {
      this.changeTab('fence');
    });
  },
  methods: {
    // 逆地理编码(谷歌、单个)
    getGoogleCode: async function (item) {
      return new Promise((resolve, reject) => {
        if (!item.lat || !item.lng) {
          reject();
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: new window.google.maps.LatLng(item.lat, item.lng) }, (results, status) => {
          // 这里处理结果和上面一模一样
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0].formatted_address);
          } else {
            reject();
          }
        });
      });
    },
    // 计算缩放程度
    computMapZoom: function (fenceScope) {
      let zoom = 3;
      if (fenceScope < 4000) {
        zoom = 16 - fenceScope / 1000;
      } else if (fenceScope < 6000) {
        zoom = 16 - fenceScope / 1600;
      } else {
        zoom = 16 - fenceScope / 2000;
      }
      return zoom;
    },
    // 缩放工具
    toolHandle: function (type) {
      if (type === 'center') {
        const { lat, lng } = this.deviceInfo;
        if (!lat || !lng) {
          return;
        }
        // const a = new window.AMap.LngLat(lng, lat);
        map.setCenter({ lng, lat });
      }
      if (type === 'add') {
        const zoom = map.getZoom();
        map.setZoom(zoom + 0.8);
      }
      if (type === 'reduce') {
        const zoom = map.getZoom();
        map.setZoom(zoom - 0.8);
      }
    },
    // 切换tab(设备围栏/辅助定位)
    changeTab: function (name) {
      if (name === 'fence') {
        this.isShowFenceDialog = false;
        this.onFenceList();
      }
      if (name === 'location') {
        this.onLocationList();
      }
      this.showTab = name;
    },
    // 初始化(谷歌地图)
    initMap: function (cb) {
      cb = cb || function () {};
      const { lat, lng } = this.deviceInfo;
      // console.log(lat);
      if (window.google) {
        map = new window.google.maps.Map(document.getElementById('container'), {
          zoom: 8,
          minZoom: 3,
          center: { lat, lng },
          mapTypeId: 'roadmap', // 卫星(satellite), 卫星和路线切换(hybrid)
        });
        this.initMapPlugin();
        cb();
        return;
      }
      this.$loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyCFJUNQ5om8G9WFr0TYMx4mA6-Gx7UiOYA&language=en-hk', ({ google }) => {
        map = new google.maps.Map(document.getElementById('container'), {
          zoom: 8,
          minZoom: 3,
          center: { lat, lng },
          mapTypeId: 'roadmap', // 卫星(satellite), 卫星和路线切换(hybrid)
        });
        this.initMapPlugin();
        cb();
      });
    },
    // 初始化地图插件（谷歌地图）
    initMapPlugin() {
      // 拖拽跟随
      map.addListener('drag', () => {
        if (circle && dit) {
          const center = map.getCenter();
          circle.setCenter(center);
          dit.setPosition(center);
          this.locForm.gpsAddress = '';
        }
      });
      map.addListener('center_changed', () => {
        if (circle && dit) {
          const center = map.getCenter();
          circle.setCenter(center);
          dit.setPosition(center);
          this.locForm.gpsAddress = '';
        }
      });
      // map.addListener('dragend', () => {
      // });
    },
    // 清除所有围栏
    fenceClear: function () {
      [...circleList, ...ditList].forEach((item) => {
        item.setMap(null);
      });
      dit = null;
      circle = null;
      circleList = [];
      ditList = [];
      this.fenceDevice();
    },
    // 渲染围栏列表
    fenceRenterList: function (fenceList) {
      this.curFence = {};
      const { lat, lng } = this.deviceInfo;
      const list = fenceList.filter(t => t.state && t.fenceType === 1);
      this.fenceClear(); // 清空地图
      list.forEach((item) => {
        const pos = JSON.parse(item.fenceData);
        this.drawCircle(pos.lng, pos.lat, item.fenceScope);
      });
      map.setCenter({ lat, lng });
      map.setZoom(15);
    },
    // 选中围栏
    onCurrentFence: function (item) {
      if (this.curFence.fenceId === item.fenceId) {
        this.curFence = {};
        this.fenceRenterList(this.fenceList);
        return;
      }
      this.curFence = item;
      this.fenceClear(); // 清空地图
      const pos = JSON.parse(item.fenceData);
      this.drawCircle(pos.lng, pos.lat, item.fenceScope);
      map.setCenter({ lng: pos.lng, lat: pos.lat });
      map.setZoom(this.computMapZoom(Number.parseInt(item.fenceScope, 10)));
    },
    // 围栏tab切换（范围/省份）
    changeFenceTab: function (value) {
      const title = this.$t('dms_device_detail_location_google.xin_zeng_wei_lan');
      if (this.fenceDialogTitle !== title) {
        return;
      }
      this.form = JSON.parse(this.resetForm);
      this.form.fenceType = value;
      this.fenceClear(); // 清空地图
      const item = this.drawCircle(); // 地图中心绘制范围
      dit = item.dit;
      circle = item.circle;
      map.setZoom(this.computMapZoom(500));
    },
    // 创建范围围栏
    drawCircle: function (lng, lat, radius = 500, isLoc) {
      if (!lng && !lat) {
        const center = map.getCenter();
        lng = center.lng();
        lat = center.lat();
      }
      // 中心
      const ditItem = new window.google.maps.Marker({
        map: map,
        zIndex: 8,
        position: { lat, lng },
        // icon:  {
        //   url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/dit.png',
        //   scaledSize: new window.google.maps.Size(14, 14),
        //   // anchor: new google.maps.Point(0, -7),
        // }
      });
      ditList.push(ditItem);
      // 范围
      const circleItem = new window.google.maps.Circle({
        map: map,
        center: { lat, lng },
        radius: Number.parseFloat(radius), // 半径
        strokeOpacity: 1,
        strokeWeight: 3,
        fillOpacity: 0.3,
        fillColor: isLoc ? '#16D071' : '#F9C851',
        strokeColor: isLoc ? '#16D071' : '#F9C851',
        zIndex: 50,
      });
      circleList.push(circleItem);
      return { dit: ditItem, circle: circleItem };
    },
    // 新增围栏
    onFenceAdd: function () {
      const title = this.$t('dms_device_detail_location_google.xin_zeng_wei_lan');
      this.fenceDialogTitle = title;
      this.changeFenceTab(1);
      this.isShowFenceDialog = true;
    },
    // 编辑围栏
    onFenceUpdate: function (row) {
      const title = this.$t('dms_device_detail_location_google.bian_ji_wei_lan');
      this.fenceDialogTitle = title;
      row.fenceScope = Number.parseInt(row.fenceScope, 10);
      this.$setFormatData(this.form, row);
      this.fenceClear();
      this.isShowFenceDialog = true;
      const pos = JSON.parse(row.fenceData);
      const item = this.drawCircle(pos.lng, pos.lat, row.fenceScope);
      dit = item.dit;
      circle = item.circle;
      map.setCenter({ lng: pos.lng, lat: pos.lat });
      map.setZoom(this.computMapZoom(Number.parseInt(row.fenceScope, 10)));
    },
    // 保存围栏(新增/编辑)
    onFenceSave: function () {
      const center = map.getCenter();
      const lng = center.lng();
      const lat = center.lat();
      this.form.fenceData = JSON.stringify({ lng, lat });
      if (!this.form.fenceName) {
        const msg = this.$t('dms_device_detail_location_google.wlmcbt');
        this.$message.error(msg);
        return;
      }
      this.form.deviceId = this.deviceInfo.deviceId;
      this.form.zoomLevel = map.getZoom();
      const title = this.$t('dms_device_detail_location_google.xin_zeng_wei_lan');
      // 新增
      if (this.fenceDialogTitle === title) {
        this.$postJSON(apis.DeviceFenceAdd, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.isShowFenceDialog = false;
          this.onFenceList();
        });
        return;
      }
      // 编辑
      this.$postJSON(apis.DeviceFenceUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.isShowFenceDialog = false;
        this.onFenceList();
      });
    },
    // 取消围栏(新增/编辑)
    onFenceCancel: function () {
      this.isShowFenceDialog = false;
      this.fenceRenterList(this.fenceList);
    },
    // 变更围栏半径
    changeSider: function (value) {
      circle.setRadius(value);
      map.setZoom(this.computMapZoom(value));
    },
    // 围栏列表
    onFenceList: function () {
      this.$getJSON(apis.DeviceFenceList, {
        deviceId: this.deviceInfo.deviceId,
      }).then((res) => {
        this.fenceList = res.data;
        this.fenceRenterList(this.fenceList);
      });
    },
    // 围栏删除
    onFenceDel: function (row) {
      this.$showConfirm(this.$t('dms_device_detail_location_google.nqdyscxzdwlm'))
        .then(() => {
          this.$postJSON(`${apis.DeviceFenceDelete}/${row.fenceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onFenceList();
          });
        })
        .catch(() => {});
    },
    // 围栏禁用/启用
    onFenceState: function (row) {
      const tips = row.state ? this.$t('dms_device_detail_location_google.nqdyjyxzdwlm') : this.$t('dms_device_detail_location_google.nqdyqyxzdwlm');
      this.$showConfirm(tips)
        .then(() => {
          this.$setFormatData(this.form, row);
          this.form.state = row.state ? 0 : 1;
          this.$postJSON(apis.DeviceFenceUpdate, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onFenceList();
          });
        })
        .catch(() => {});
    },
    // 辅助列表
    onLocationList: function () {
      this.$getJSON(apis.DeviceLocationList, {
        deviceId: this.deviceInfo.deviceId,
      }).then((res) => {
        this.locationList = res.data;
        this.fenceLosRenter(this.locationList);
      });
    },
    // 渲染辅助列表
    fenceLosRenter: function (fenceList) {
      this.curLocation = {};
      const { lat, lng } = this.deviceInfo;
      const list = fenceList.filter(t => t.state);
      this.fenceClear(); // 清空地图
      list.forEach((item) => {
        this.drawCircle(item.lng, item.lat, item.fenceScope, true);
      });
      map.setCenter({ lat, lng });
      map.setZoom(15);
    },
    // 选中辅助
    onCurrentLocation: function (item) {
      if (this.curLocation.locationId === item.locationId) {
        this.curLocation = {};
        this.fenceLosRenter(this.locationList);
        return;
      }
      this.fenceClear(); // 清空地图
      this.curLocation = item;
      this.drawCircle(item.lng, item.lat, item.radius, true); // 地图绘制范围
      map.setCenter({ lng: item.lng, lat: item.lat });
      map.setZoom(this.computMapZoom(item.radius));
    },
    // 取消辅助(新增/编辑)
    onLocationCancel: function () {
      this.isShowLocationDialog = false;
      this.fenceLosRenter(this.locationList);
    },
    // 新增辅助
    onLocationAdd: function () {
      const title = this.$t('dms_device_detail_location_google.xzfzdw');
      this.fenceDialogTitle = title;
      this.locForm = JSON.parse(this.resetLocForm);
      this.isShowLocationDialog = true;
      this.fenceClear(); // 清空地图
      const item = this.drawCircle(null, null, 500, true); // 地图中心绘制范围
      dit = item.dit;
      circle = item.circle;
      map.setZoom(this.computMapZoom(500));
    },
    // 编辑辅助
    onLocationUpdate: function (row) {
      const title = this.$t('dms_device_detail_location_google.bjfzdw');
      this.fenceDialogTitle = title;
      this.$setFormatData(this.locForm, row);
      this.fenceClear();
      this.isShowLocationDialog = true;
      const item = this.drawCircle(row.lng, row.lat, row.radius, true);
      dit = item.dit;
      circle = item.circle;
      map.setCenter({ lng: row.lng, lat: row.lat });
      map.setZoom(this.computMapZoom(Number.parseInt(row.radius, 10)));
      this.$setFormatData(this.locForm, row); // 位置信息被清除需要重新辅助
    },
    // 辅助删除
    onLocationDel: function (row) {
      this.$showConfirm(this.$t('dms_device_detail_location_google.nqdyscxzdfzdwm'))
        .then(() => {
          this.$postJSON(`${apis.DeviceLocationDelete}/${row.locationId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onLocationList();
          });
        })
        .catch(() => {});
    },
    // 保存辅助(新增/编辑)
    onLocationSave: async function () {
      const title = this.$t('dms_device_detail_location_google.xzfzdw');
      const center = map.getCenter();
      this.locForm.lat = center.lat();
      this.locForm.lng = center.lng();
      this.locForm.deviceId = this.deviceInfo.deviceId;
      await this.getGeocoder();
      // 新增辅助
      if (this.fenceDialogTitle === title) {
        this.$postJSON(apis.DeviceLocationAdd, this.locForm).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.isShowLocationDialog = false;
          this.onLocationList();
        });
        return;
      }
      // 编辑辅助
      this.$postJSON(apis.DeviceLocationUpdate, this.locForm).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.isShowLocationDialog = false;
        this.onLocationList();
      });
    },
    // 辅助禁用/启用
    onLocationState: function (row) {
      const tips = row.state ? this.$t('dms_device_detail_location_google.nqdyjyxzdfzdwm') : this.$t('dms_device_detail_location_google.nqdyqyxzdfzdwm');
      this.$showConfirm(tips)
        .then(() => {
          this.$setFormatData(this.locForm, row);
          this.locForm.state = row.state ? 0 : 1;
          this.$postJSON(apis.DeviceLocationUpdate, this.locForm).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onLocationList();
          });
        })
        .catch(() => {});
    },
    // 位置信息
    getGeocoder: async function () {
      if (this.locForm.gpsAddress) {
        return;
      }
      const center = map.getCenter();
      const lng = center.lng();
      const lat = center.lat();
      this.locForm.gpsAddress = (await this.getGoogleCode({ lng, lat }).catch(() => {})) || 'Unknown address';
    },
    // 设备位置
    fenceDevice: function () {
      const { lat, lng } = this.deviceInfo;
      if (!lat || !lng) {
        return;
      }
      const marker = new window.google.maps.Marker({
        map: map,
        zIndex: 10,
        position: { lat, lng },
        icon: {
          url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/WechatIMG406 2.png',
          scaledSize: new window.google.maps.Size(41, 58),
        },
      });
      ditList.push(marker);
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-location-bd {
  position: relative;
  height: calc(100% - 72px);
  .gm-control-active.gm-fullscreen-control {
    display: none;
  }
  .gm-style-mtc button {
    font-size: 14px !important;
  }
  .gm-svpc {
    display: none;
  }
  .gm-bundled-control {
    display: none !important;
  }
  &.full-screen {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto;
    margin: 0;
    padding: 0;
  }
  .device-detail-location-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .full-btn {
    width: 36px;
    height: 36px;
    cursor: pointer;
    background-color: #ffffff;
    color: #495057;
    line-height: 36px;
    text-align: center;
    margin-right: 17px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    .icon {
      font-size: 16px;
    }
  }
  .tab-box {
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 190;
    &.tab {
      left: auto;
      right: 0;
    }
    .ub {
      margin-right: 16px;
      border-radius: 2px;
      overflow: hidden;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    }
    .ub-f1 {
      background-color: #ffffff;
      line-height: 36px;
      height: 36px;
      padding: 0 15px;
      color: #6c757d;
      font-size: 12px;
      cursor: pointer;
      &.cur {
        background-color: #0d9ae0;
        color: #ffffff;
      }
    }
  }
  .amap-tool {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 199;
    .location {
      cursor: pointer;
      background-color: #ffffff;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      width: 32px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      .icon {
        color: #646464;
        font-size: 16px;
      }
    }
    .zoom {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-top: 10px;
      background-color: #ffffff;
      text-align: center;
      align-items: center;
      .icon {
        cursor: pointer;
        color: #646464;
        font-size: 16px;
        line-height: 37px;
      }
      .bar {
        background-color: rgba(0, 0, 0, 0.1);
        height: 1px;
        width: 24px;
      }
    }
  }
  .amap-info-content {
    position: relative;
    border-radius: 2px;
    padding: 16px 18px 16px 16px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .amap-info-close {
    display: none;
  }
  .address {
    color: #99a6ad;
    font-size: 12px;
    line-height: 22px;
    i {
      font-size: 16px;
      margin-right: 2px;
      margin-top: 2px;
      float: left;
    }
  }
  .product {
    .img-box {
      width: 44px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      padding-left: 10px;
      h1 {
        color: #495057;
        line-height: 20px;
        font-size: 14px;
        margin-bottom: 3px;
        font-weight: bold;
      }
      p {
        line-height: 17px;
        font-size: 12px;
        color: #495057;
      }
    }
  }

  position: relative;
  margin: 16px;

  h1.tit {
    line-height: 44px;
    color: #394668;
    font-size: 14px;
    font-weight: bold;
    background: rgba(248, 249, 251, 1);
    padding: 0 16px;
    span {
      cursor: pointer;
      font-weight: normal;
      font-size: 12px;
      float: right;
      color: #6c757d;
    }
    .icon {
      color: #0d9ae0;
    }
    .up {
      display: block;
      transform: rotate(90deg);
    }
  }

  .aside-box {
    position: absolute;
    background-color: #ffffff;
    top: 16px;
    right: 16px;
    width: 300px;
    z-index: 190;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    .marks-tip {
      justify-content: space-between;
      line-height: 16px;
      color: #6c757d;
      font-size: 12px;
      margin-top: -6px;
    }
    .aside-tab {
      margin-top: 16px;
      margin-bottom: 18px;
      .ub-f1 {
        line-height: 26px;
        height: 28px;
        border: 1px solid #dee2e6;
        color: #6c757d;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        &:first-child {
          border-right: none;
          border-radius: 2px 0px 0px 2px;
        }
        &:last-child {
          border-left: none;
          border-radius: 0px 2px 2px 0px;
        }
        &.cur {
          border: none;
          background-color: #0d9ae0;
          color: #ffffff;
        }
      }
    }
  }
  .fence-list {
    position: absolute;
    background-color: #ffffff;
    top: 67px;
    right: 16px;
    width: 300px;
    z-index: 190;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    .add-fence {
      cursor: pointer;
      background: rgba(248, 249, 251, 1);
      border-radius: 2px;
      border: 1px dashed rgba(228, 228, 228, 1);
      color: rgba(73, 80, 87, 1);
      line-height: 32px;
      font-size: 12px;
      text-align: center;
      margin-top: 16px;
      .icon {
        color: #0d9ae0;
      }
    }
    ul {
      margin-top: 16px;
    }
    ul li {
      height: 38px;
      line-height: 38px;
      span {
        text-indent: 4px;
        color: #495057;
        font-size: 12px;
        cursor: pointer;
      }
      .icon {
        cursor: pointer;
        color: #0d9ae0;
        font-size: 13.5px;
        margin: 0 7px;
      }
      &.cur {
        background: rgba(248, 249, 251, 1);
        span {
          color: #0d9ae0;
        }
      }
      &.disable span {
        color: #d1d1d1;
      }
    }
  }
  .input-card {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 190;
    padding: 0.75rem 1.25rem;
    background-color: #fff;
    .btn {
      display: inline-block;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid transparent;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      background-color: transparent;
      background-image: none;
      color: #25a5f7;
      border-color: #25a5f7;
      padding: 0.25rem 0.5rem;
      line-height: 1.5;
      border-radius: 1rem;
      -webkit-appearance: button;
      cursor: pointer;
    }
  }
}
#container {
  width: 100%;
  height: 100%;
}
</style>
